<app-admin-list-page [title]="'Videos' | translate">

  <a slot="actions" class="btn btn-primary" routerLink="/admin/externalpage/Video">
    {{'Add new' | translate}}
  </a>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
